import React, { useState } from 'react';

import TrainWeeklySchedule from '../../components/TrainWeeklySchedule';
import TrainInfoContext from '../TrainInfoContext';

import { TrainDetailsData } from '../../types';

import capitalise from '../../../utils/capitalise';
import { useContext } from 'react';
import { crawlerDuplicateAvoidStyle } from '../../../utils/commonUtils';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_TRAIN_PAGE } from '../../../utils/RailsSEOConstants';

type TrainInfoListItemProps = {
  train: TrainDetailsData;
  onClick: (TrainDetails, isMobile) => void;
};

const TrainInfoListItem = ({ train, onClick }: TrainInfoListItemProps) => {
  const isMobile = () => window && window.innerWidth < 767;
  const trainsData = useContext(TrainInfoContext);
  const [isFocussed, setIsFocussed] = useState(false);
  const updateIsFocussed = (latestIsFocussed) => {
    setIsFocussed(latestIsFocussed);
  };
  return (
    <div
      role="button"
      className={`railSeoWrap__infoTable--info cursorPointer`}
      onClick={() => {
        trackClickEventProp61(SEO_TRAIN_PAGE, 'rail_seo_train_otherroutes_clicked');
        onClick(train, isMobile());
      }}
      onPointerEnter={() => updateIsFocussed(true)}
      onPointerLeave={() => updateIsFocussed(false)}
    >
      <a
        className={`railSeoWrap__infoTable--trainInfo ${isFocussed ? 'colorBlue' : ''}`}
        onClick={(e) => {
          e.preventDefault();
        }}
        href={train.trainPageUrl}
      >
        <span className={`railSeoWrap__infoTable--railNo ${isFocussed ? 'colorBlue' : ''}`}>{train.trainNumber} -</span>
        <h4 className={`railSeoWrap__infoTable--railName ${isFocussed ? 'colorBlue' : ''}`}>{train.trainName}</h4>
      </a>
      <div style={crawlerDuplicateAvoidStyle} className="mobileShow appendBottom10">
        <span className={`railSeoWrap__infoTable--srvcTxt ${isFocussed ? 'colorBlue' : ''}`}>
          {trainsData.miscellaneous['SERVICE DAYS']} :{' '}
        </span>
        <TrainWeeklySchedule trainSchedule={train.trainWeeklySchedule} />
      </div>
      <div className={`railSeoWrap__infoTable--time`}>
        <div className={`railSeoWrap__infoTable--left`}>
          <span className={`railSeoWrap__infoTable--startTime ${isFocussed ? 'colorBlue' : ''}`}>
            {train.departureTime}
          </span>
          <span className={`railSeoWrap__infoTable--stn`}>
            <span className={`railSeoWrap__infoTable--stnShrtName ${isFocussed ? 'colorBlue' : ''}`}>
              {train.sourceStn}
            </span>
            <span className={`railSeoWrap__infoTable--stnFullNm ${isFocussed ? 'colorBlue' : ''}`}>
              {capitalise(train.sourceStnName)}
            </span>
          </span>
        </div>
        <div className={`railSeoWrap__infoTable--mid`} style={{ paddingBottom: 10 }}>
          <span className="hrLine80">&nbsp;</span>
          <span className={`appendLeft5 appendRight5 noWordBreak ${isFocussed ? 'colorBlue' : ''}`}>
            {train.duration}
          </span>
          <span className="hrLine80">&nbsp;</span>
        </div>
        <div className={`railSeoWrap__infoTable--right`}>
          <span className={`railSeoWrap__infoTable--endTime ${isFocussed ? 'colorBlue' : ''}`}>
            {train.arrivalTime}
          </span>
          <span className={`railSeoWrap__infoTable--stn`}>
            <span className={`railSeoWrap__infoTable--stnShrtName ${isFocussed ? 'colorBlue' : ''}`}>
              {train.destinationStn}
            </span>
            <span className={`railSeoWrap__infoTable--stnFullNm ${isFocussed ? 'colorBlue' : ''}`}>
              {capitalise(train.destinationStnName)}
            </span>
          </span>
        </div>
      </div>
      <div className="desktopShow">
        <span className={`railSeoWrap__infoTable--srvcTxt ${isFocussed ? 'colorBlue' : ''}`}>
          {trainsData.miscellaneous['SERVICE DAYS']} :{' '}
        </span>
        <TrainWeeklySchedule trainSchedule={train.trainWeeklySchedule} />
      </div>
    </div>
  );
};

type TrainInfoListProps = {
  trains: TrainDetailsData[];
  title: string;
};

export default function TrainInfoList({ title, trains }: TrainInfoListProps) {
  const trainsData = useContext(TrainInfoContext);
  return (
    <section>
      <h2 className="railSeoWrap__infoTable--title desktopShow capText">{title}</h2>
      <div className="railSeoWrap__infoTable">
        <h3 style={crawlerDuplicateAvoidStyle} className="mobileShow font22 latoLight">
          {trainsData.miscellaneous['TRAIN ROUTES']}
        </h3>
        <h3 style={crawlerDuplicateAvoidStyle} className="railSeoWrap__infoTable--title mobileShow">
          {title}
        </h3>
        {trains.map((t, idx) => (
          <TrainInfoListItem key={`${t.trainNumber}_${idx}`} train={t} onClick={trainsData.onTrainClicked} />
        ))}
      </div>
    </section>
  );
}
